module.exports = __webpack_public_path__ + "img/undo-button-grey.193f2b62.svg";